module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contain"
  }, [_c('van-popup', {
    style: ({
      height: '70%'
    }),
    attrs: {
      "position": "bottom",
      "close-on-click-overlay": false
    },
    on: {
      "click-overlay": _vm.onClose
    },
    model: {
      value: (_vm.isShow),
      callback: function($$v) {
        _vm.isShow = $$v
      },
      expression: "isShow"
    }
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('van-search', {
    attrs: {
      "placeholder": "请输关键字搜索"
    },
    on: {
      "input": _vm.onSearch
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "44px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('div', {
    staticClass: "add-item",
    on: {
      "click": _vm.memberAdd
    }
  }, [_vm._v("\n        新增运动员\n      ")]), _vm._v(" "), (_vm.options.length > 0) ? _c('van-cell-group', _vm._l((_vm.options), function(item, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "clickable": "",
        "label": (item.sex == 1 ? '男' : '女') + ' ' + item.num,
        "v-if": index < _vm.limit
      },
      on: {
        "click": function($event) {
          return _vm.toggle(item)
        }
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticClass: "custom-title"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('van-checkbox', {
      attrs: {
        "slot": "right-icon",
        "checked-color": "#FD2840"
      },
      slot: "right-icon",
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    })], 2)
  }), 1) : _c('div', {
    staticClass: "noresult"
  }, [_vm._v("\n        没有记录...\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "createbtn"
  }, [(_vm.options.length == 0 && !_vm.keywords) ? _c('van-button', {
    attrs: {
      "type": "danger",
      "native-type": "button",
      "size": "large"
    },
    on: {
      "click": _vm.memberAdd
    }
  }, [_vm._v("新增运动员")]) : _c('van-button', {
    attrs: {
      "type": "danger",
      "native-type": "button",
      "size": "large"
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '60%'
    }),
    attrs: {
      "position": "bottom"
    },
    on: {
      "click-overlay": function($event) {
        _vm.addShow = false
      }
    },
    model: {
      value: (_vm.addShow),
      callback: function($$v) {
        _vm.addShow = $$v
      },
      expression: "addShow"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "0.2rem",
      "margin-bottom": "1.5rem"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("新增运动员")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "姓名",
      "rules": [{
        required: true,
        message: '姓名不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "证件类型"
    },
    on: {
      "click": function($event) {
        _vm.showNumTypePicker = true
      }
    },
    model: {
      value: (_vm.formData.numTypeName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "numTypeName", $$v)
      },
      expression: "formData.numTypeName"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showNumTypePicker),
      callback: function($$v) {
        _vm.showNumTypePicker = $$v
      },
      expression: "showNumTypePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.numTypeColumns,
      "show-toolbar": "",
      "default-index": _vm.formData.cardtype - 1
    },
    on: {
      "cancel": function($event) {
        _vm.showNumTypePicker = false
      },
      "confirm": _vm.onNumTypeConfirm
    }
  })], 1), _vm._v(" "), (_vm.formData.cardtype == 1) ? _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.idCard,
        message: '请输入正确的身份证号'
      }],
      "error-message-align": "right",
      "label": "身份证号",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.cardtype != 1) ? _c('van-field', {
    attrs: {
      "label": "证件号码",
      "rules": [{
        required: true,
        message: '证件号码不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入证件号码"
    },
    model: {
      value: (_vm.formData.huzhao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "huzhao", $$v)
      },
      expression: "formData.huzhao"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showBirthday) ? _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "label": "生日",
      "input-align": "right",
      "error-message-align": "right",
      "placeholder": "请选择生日",
      "rules": [{
        required: true,
        message: '请选择生日'
      }]
    },
    on: {
      "click": function($event) {
        _vm.showDate = true
      }
    },
    model: {
      value: (_vm.formData.birthday),
      callback: function($$v) {
        _vm.$set(_vm.formData, "birthday", $$v)
      },
      expression: "formData.birthday"
    }
  }) : _vm._e(), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showDate),
      callback: function($$v) {
        _vm.showDate = $$v
      },
      expression: "showDate"
    }
  }, [_c('van-datetime-picker', {
    attrs: {
      "type": "date",
      "title": "选择年月日",
      "min-date": _vm.minDate,
      "max-date": _vm.maxDate
    },
    on: {
      "confirm": _vm.onDateConfirm,
      "cancel": function($event) {
        _vm.showDate = false
      }
    },
    model: {
      value: (_vm.currentDate),
      callback: function($$v) {
        _vm.currentDate = $$v
      },
      expression: "currentDate"
    }
  })], 1), _vm._v(" "), (_vm.showSex) ? _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "性别",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.sex),
            callback: function($$v) {
              _vm.$set(_vm.formData, "sex", $$v)
            },
            expression: "formData.sex"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": 1
          }
        }, [_vm._v("男")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": 2
          }
        }, [_vm._v("女")])], 1)]
      },
      proxy: true
    }], null, false, 2706601976)
  }) : _vm._e(), _vm._v(" "), (_vm.showJianhu) ? _c('van-field', {
    attrs: {
      "label": "监护人姓名",
      "rules": [{
        required: true,
        message: '监护人姓名不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入监护人姓名"
    },
    model: {
      value: (_vm.formData.jianhuname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "jianhuname", $$v)
      },
      expression: "formData.jianhuname"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showJianhu) ? _c('van-field', {
    attrs: {
      "label": "监护人证件号码",
      "rules": [{
        required: true,
        message: '监护人证件号码不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入监护人证件号码"
    },
    model: {
      value: (_vm.formData.jianhunum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "jianhunum", $$v)
      },
      expression: "formData.jianhunum"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showJianhu) ? _c('van-field', {
    attrs: {
      "label": "监护人手机",
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入监护人手机"
    },
    model: {
      value: (_vm.formData.jianhuphone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "jianhuphone", $$v)
      },
      expression: "formData.jianhuphone"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中...",
      "native-type": "submit"
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f2d61f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picker/YundongyuanPicker.vue
// module id = 2269
// module chunks = 0